export const PRESET_TABLE_EMPTY_STATE = (
  <div className="rounded border border-dashed border-gray-300 p-4 text-sm text-gray-500">
    No marker data available for this block yet.
  </div>
);
